var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"filter-title"},[_vm._v("Challenge")]),_vm._v(" "),_vm._l((_vm.$store.state.event.data.challenges),function(challenge){return _c('router-link',{key:challenge.nom,staticClass:"button_course",class:{
      isCurrent: _vm.$store.state.event.selection.challenge === challenge.nom,
    },attrs:{"type":"button","size":"sm","target":"_self","to":{
        name: 'Challenge',
        query: { id: _vm.$store.state.event.id, c: challenge.nom },
      },"refresh":""}},[_vm._v(_vm._s(challenge.nom))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }